module.exports = "/assets/b1649921d5adbbccbdcc065dd2474644.svg";